export const CAREERS_JOBS = [
  {
    slug: 'concierge-specialist',
    jobId: '23234',
    openings: [
      { location: 'Remote' },
      { location: 'New York, NY' }
    ],
    title: 'Concierge Specialist',
    department: 'Customer Experience',
    location: 'Remote & New York, NY',
    intro: 'Defera exists to make travel accessible for everyone. We\'re looking for Concierge Specialists who are passionate about helping travelers—especially those who\'ve been shut out by traditional booking—navigate their trips with confidence. If you love solving problems, communicating clearly, and turning stressed customers into happy ones, we want to hear from you.',
    team: 'The Customer Experience team is the front line of Defera. We handle everything from booking support and payment questions to travel changes and Miles redemptions. We\'re a small, high-trust group that moves fast and cares deeply about getting it right.',
    youWill: [
      'Support travelers via email, chat, and phone—answering questions about bookings, payments, and our installment plans',
      'Troubleshoot issues with flights, payments, and account access',
      'Help customers redeem Defera Miles for e-gift cards and understand our rewards program',
      'Escalate complex issues and work with operations to resolve them',
      'Contribute to our knowledge base and help improve our support processes'
    ],
    ideallyHave: [
      '2+ years of customer support or concierge experience',
      'Clear, empathetic communication—written and verbal',
      'Comfort with ambiguity and the ability to figure things out',
      'Patience and a genuine desire to help people',
      'Basic familiarity with travel booking or fintech'
    ],
    niceToHave: [
      'Experience in travel, hospitality, or fintech',
      'Bilingual (Spanish a plus)',
      'Experience with Zendesk, Intercom, or similar tools'
    ],
    compensation: 'Compensation includes base salary and benefits. The range for this role is $45,000—$55,000 USD depending on experience and location.'
  },
  {
    slug: 'regional-director',
    jobId: '23235',
    openings: [{ location: 'San Francisco, CA' }],
    title: 'Regional Director',
    department: 'Operations',
    location: 'San Francisco, CA',
    intro: 'Defera is scaling our presence in key markets. We\'re looking for a Regional Director to own our West Coast operations—building partnerships, driving growth, and ensuring we deliver for travelers and airline partners in the region. If you\'re an operator who thrives in a fast-paced environment and wants to shape how travel gets financed, this role is for you.',
    team: 'The Operations team at Defera sits at the intersection of travel, payments, and customer success. We work closely with airlines, payment partners, and internal teams to keep the engine running. The Regional Director will have significant autonomy to build and run their region.',
    youWill: [
      'Own regional performance—bookings, revenue, and customer satisfaction for your territory',
      'Build and maintain relationships with airline partners and key stakeholders',
      'Identify growth opportunities and execute on them',
      'Collaborate with product, engineering, and support to improve the customer experience',
      'Represent Defera at industry events and in partner conversations',
      'Report to leadership on regional metrics and strategic initiatives'
    ],
    ideallyHave: [
      '5+ years of experience in operations, business development, or account management',
      'Background in travel, fintech, or a related industry',
      'Strong analytical skills and comfort with data',
      'Proven ability to build relationships and close deals',
      'Self-directed with a bias for action'
    ],
    niceToHave: [
      'MBA or equivalent experience',
      'Existing relationships in the travel or payments industry',
      'Experience scaling a regional operation from the ground up'
    ],
    compensation: 'Compensation includes base salary, equity, and benefits. The base salary range for this role in San Francisco is $120,000—$150,000 USD, depending on experience.'
  }
];
